import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class CouponReview extends Component {
    constructor(props) {
        super(props);
        this.DATES_FORMAT = 'MMMM Do, YYYY';
    }

    renderCouponCodes = () => {
        if (this.props.couponCodes.length > 0) {
            return (
                <div className="table-responsive">
                    <table id="couponCodesTbl" className="showtix-table showtix-table__striped showtix-table__fixed-height">
                        <thead>
                            <tr>
                                <th style={{ width: 20 }}>
                                    <div className="showtix-form__checkbox">
                                        <input
                                            type="checkbox"
                                            className="showtix-input"
                                            id="input-coupon-all"
                                            value="true"
                                            onChange={this.props.selectAllCouponCheckboxes}
                                        />
                                        <label className="showtix-label" htmlFor="input-coupon-all"></label>
                                    </div>
                                </th>
                                <th style={{ width: 200 }}>{strings.couponsTable.code}</th>
                                <th style={{ width: 200 }}>{strings.couponsTable.status}</th>
                                <th style={{ width: 200 }}>{strings.couponsTable.customerName}</th>
                                <th style={{ width: 200 }}>{strings.couponsTable.transactionNumber}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.couponCodes.map((coupon, i) => {
                                    let customerName = (coupon.customer && coupon.customer.first_name && coupon.customer.last_name) ? coupon.customer.first_name + " " + coupon.customer.last_name : "-";
                                    let transactionNumber = (coupon.transactionId && coupon.transactionId !== "") ? coupon.transactionId : "-";
                                    return (
                                        <tr key={i}>
                                            <td style={{ width: 20 }}>
                                                <div className="showtix-form__checkbox">
                                                    {this.renderCouponCheckbox(coupon)}
                                                </div>
                                            </td>
                                            <td style={{ width: 200 }}>
                                                {coupon.code} 
                                            </td>
                                            <td style={{ width: 200 }}>
                                                {this.getCouponStatus(coupon)}
                                            </td>
                                            <td style={{ width: 200 }}>
                                                {customerName}
                                            </td>
                                            <td style={{ width: 200 }}>
                                                {transactionNumber}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            );
        } else {
            return (
                <p>{strings.noCoupons}</p>
            );
        }
    }

    renderCouponCheckbox = (coupon) => {
        if (coupon.status.toLowerCase() !== 'redeemed') {
            return (
                <span>
                    <input
                        type="checkbox"
                        className="showtix-input"
                        id={"input-coupon-" + coupon.id}
                        value={coupon.id}
                        onClick={this.props.updateSelectedCoupon}
                    />
                    <label className="showtix-label" htmlFor={"input-coupon-" + coupon.id}></label>
                </span>
            )
        }
    }

    getCouponStatus = (coupon) => {
        if(coupon.usedCount === coupon.nbRedemption) {
            return <span className="showtix-badge warning">{strings.redeemed}</span>;
        } else {
            return (
                coupon.usedCount + "/" + coupon.nbRedemption
            );
        }
    }

    renderCouponValue = (couponDetails) => {
        let string = strings.perTransaction;
        switch (couponDetails.couponValueType) {
            case 'percent':
            string = strings.percent;
            break;

            case 'per-ticket':
            string = strings.perTicket;
            break;
        }

        return string;
    };
    
    render() {
        let couponDetails = this.props.couponDetails;
        return ( 
            <div className={this.props.isSecondStepOpen === true ? "showtix-coupon-form__second-step is-active" : "showtix-coupon-form__second-step"}>
                <div className="showtix-section showtix-section__padding-1 showtix-background__primary-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-12"><h1 className="mb-2">{strings.title}</h1></div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-lg-6">
                                <h3 className="showtix-font-weight-light mb-0">
                                    <strong>{strings.couponName}</strong>:&nbsp;
                                    {couponDetails.couponName}
                                </h3>
                            </div>

                            <div className="col-12 col-lg-6">
                                <h3 className="showtix-font-weight-light mb-0">
                                    <strong>{strings.couponValue}</strong>:&nbsp;
                                    {couponDetails.couponValue}&nbsp;
                                    {this.renderCouponValue(couponDetails)}
                                </h3>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-lg-6">
                                <h3 className="showtix-font-weight-light mb-0">
                                    <strong>{strings.couponDescription}</strong>:&nbsp;
                                    {couponDetails.couponDescription}
                                </h3>
                            </div>
                            <div className="col-12 col-lg-6">
                                <h3 className="showtix-font-weight-light mb-0">
                                    {strings.validFrom}&nbsp;
                                    {moment(couponDetails.couponStartDate).format(this.DATES_FORMAT)}&nbsp;
                                    {strings.validTo}&nbsp;
                                    {moment(couponDetails.couponEndDate).format(this.DATES_FORMAT)}
                                </h3>
                            </div>
                        </div>

                        {couponDetails.couponType === "multiple" &&
                        <div>
                            <div className="row mt-3">
                                <div className="col-12 col-lg-9 text-left">
                                    { this.renderCouponCodes() }
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-12 col-md-12">
                                    <button 
                                        className="showtix-button showtix-background__primary-1"
                                        onClick={this.props.downloadCoupons}
                                        disabled={!this.props.isReadyToSelectCodes}>
                                        {strings.downloadBtn}
                                    </button>
                                    <button 
                                        className="showtix-button showtix-background__primary-1"
                                        onClick={this.props.printers.length === 0 || this.props.printers.length > 1 ? this.toggleAlertModal : this.props.printCoupon}
                                        disabled={!this.props.selectedCodes.length > 0}>
                                        {strings.printBtnDymo}
                                    </button>
                                    <button
                                        className="showtix-button showtix-background__primary-1"
                                        onClick={this.props.printersBoca.length === 0 || this.props.printersBoca.length >= 1 ? this.props.toggleAlertModalBoca : this.props.printCouponBoca}
                                        disabled={!this.props.selectedCodes.length > 0}>
                                        {strings.printBtnBoca}
                                    </button>
                                    <button
                                        className="showtix-button showtix-background__primary-1"
                                        onClick={this.props.printersStar.length === 0 || this.props.printersStar.length >= 1 ? this.props.toggleAlertModalStar : this.props.printCouponStar}
                                        disabled={!this.props.selectedCodes.length > 0}>
                                        {strings.printBtnStar}
                                    </button>
                                </div>
                            </div>
                        </div>
                        }

                        {couponDetails.couponType === "single" && this.props.couponCodes.length > 0 &&
                        <div>
                            <hr className="color-2" />

                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="usedRedemptions">
                                            {strings.usedRedemptions.text}
                                            <span id="tooltip-usedRedemptions" className="showtix-tooltip">!</span>
                                            <Tooltip placement="top" target="tooltip-usedRedemptions">
                                                {strings.usedRedemptions.tooltip}
                                            </Tooltip>
                                        </label>
                                        <div className="showtix-form__input">
                                            <input
                                                className="showtix-input"
                                                type="text"
                                                name="usedRedemptions"
                                                id="usedRedemptions"
                                                value={this.props.couponCodes[0].usedCount}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-lg-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="availRedemptions">
                                            {strings.availRedemptions.text}
                                            <span id="tooltip-availRedemptions" className="showtix-tooltip">!</span>
                                            <Tooltip placement="top" target="tooltip-availRedemptions">
                                                {strings.availRedemptions.tooltip}
                                            </Tooltip>
                                        </label>
                                        <div className="showtix-form__input">
                                            <input
                                                className="showtix-input"
                                                type="text"
                                                name="availRedemptions"
                                                id="availRedemptions"
                                                value={this.props.couponCodes[0].nbRedemption-this.props.couponCodes[0].usedCount}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

CouponReview.propTypes = {
    couponCodes: PropTypes.array,
    couponDetails: PropTypes.object,
    activeCoupon: PropTypes.object,
    couponExists: PropTypes.bool,
    isReadyToSelectCodes: PropTypes.bool,
    selectAllCouponCheckboxes: PropTypes.func,
    updateSelectedCoupon: PropTypes.func,
    downloadCoupons: PropTypes.func,
    printCoupon: PropTypes.func
}
 
export default CouponReview;


// WEBPACK FOOTER //
// ./src/components/CreateCoupon/CouponReview/CouponReview.js